import styled, { css } from "styled-components"

import { SvgIcon } from "@components/common"
import { MEDIA_SIZES } from "assets/styles/mediaSizes"

// TEEUP-INSIDE 2026-07-03: header restructured to Ale's ".detail-hero" shape ported verbatim
// from coowe.html (border-radius 18px, 44px/28px/40px padding, centered column layout, dark
// gradient scrim over the cover photo so white top-row icons + chip + title stay legible on any
// image). Spec: state chip sits AT THE TOP of the header, above/with the title; gear top-right.
export const Wrapper = styled.section`
  ${({ $photo }) => css`
    position: relative;
    width: 100%;
    min-height: 236px;
    background: ${$photo
      ? `url("${$photo}") center / cover no-repeat`
      : "var(--gray3)"};
    border-radius: 18px;
    box-sizing: border-box;
    overflow: hidden;

    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 44px 28px 32px;

    /* Ale's .hero-bg:before gradient scrim -- keeps white chip/title/icons legible over any photo */
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      background: linear-gradient(180deg, #12101685, #0e0d13ad);
      backdrop-filter: blur(1.5px);
      -webkit-backdrop-filter: blur(1.5px);
      z-index: 0;
    }

    > * {
      position: relative;
      z-index: 1;
    }

    @media (max-width: ${MEDIA_SIZES.MOBILE}) {
      width: 100vw;
      min-height: 150px;
      padding: 14px 16px 20px;
      border-radius: 0;
    }
  `};
`

// Top row: back arrow (left), stage chip + gear grouped top-right (iPhone parity --
// teeupHeaderActions/index.tsx groups the status chip immediately left of the settings/ellipsis
// button, both absolute top-right over the cover). The title sits below on its own line and gains
// visual primacy now that the chip no longer floats above/over it.
export const Line = styled.div`
  width: 100%;
  height: max-content;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Title = styled.h2`
  margin: 20px 0 0;
  padding: 0 8px;
  font-size: 24px;
  font-weight: 500;
  letter-spacing: -0.025em;
  text-align: center;
  color: #fff;
  text-shadow: 0 1px 14px rgba(0, 0, 0, 0.4);

  @media (max-width: ${MEDIA_SIZES.MOBILE}) {
    font-size: 18px;
  }
`

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`

export const DropdownWrapper = styled.div`
  position: relative;

  .dropdown.dropdown--high {
    margin-top: 0;
  }
`

export const SettingsWrapper = styled.div`
  ${({ $isDisabled }) => css`
    width: 44px;
    height: 44px;
    background: var(--transparentWhite);
    border-radius: 50%;
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;

    &:active {
      opacity: 0.4;
    }
    ${$isDisabled &&
    css`
      opacity: 0.4;
    `};
  `};
`

export const SettignsIcon = styled(SvgIcon)`
  width: 15px;
  height: 15px;
`
